import { useMutation, useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { Button } from 'ui';
import { putSwapRejectOffer } from '~/api/swapDetails/api';
import { swapByIdQuery } from '~/api/swapDetails/queries';
import ErrorMessage from '~/components/Form/ErrorMessage';
import ConfirmationModal from '~/components/NewModal/ConfirmationModal';
import { RailsSwapDetail } from '~/typings/services/rails/swaps';

interface Props {
  swapDetails: RailsSwapDetail;
}

const SwapActionRejectOffer: React.FC<Props> = ({ swapDetails }) => {
  const { refetch } = useQuery(swapByIdQuery(undefined, swapDetails.id));
  const [open, setOpen] = useState(false);

  const { error, mutate, isLoading } = useMutation(
    () => putSwapRejectOffer(swapDetails.id, swapDetails.current_offer_id),
    {
      onSuccess: async () => {
        setOpen(false);
        await refetch();
      },
    },
  );

  return (
    <>
      <Button onClick={() => setOpen(true)} color="secondary" fluid>
        Reject Offer
      </Button>

      <ConfirmationModal
        open={open}
        onClose={() => setOpen(false)}
        title="Are you sure you want to reject their offer?"
        handleOK={mutate}
        loading={isLoading}
      >
        <ErrorMessage errors={error} />
      </ConfirmationModal>
    </>
  );
};

export default SwapActionRejectOffer;
